type Props = {
  name: string;
  backgroundColor: string;
  fontColor: string;
  borderColor: string;
};

export const RecruitmentTag = ({ name, backgroundColor, borderColor, fontColor }: Props) => {
  return (
    <>
      <span className={`mr-2 text-xs font-bold rounded p-1 tag`}>{name}</span>
      <style jsx>{`
        .tag {
          color: ${fontColor};
          background-color: ${backgroundColor};
          border: 1px solid ${borderColor};
        }
      `}</style>
    </>
  );
};
